import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ProductsPage } from "./pages/ProductsPage";
import { SpreadGeniusPage } from "./pages/SpreadGeniusPage";
import { ExpatHorizonPage } from "./pages/ExpatHorizonPage";
import { SchwabIntegrationPage } from "./pages/SchwabIntegrationPage";
import { ServicesPage } from "./pages/ServicesPage";
import { ContactPage } from "./pages/ContactPage";
import "./App.css";

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/spread-genius" element={<SpreadGeniusPage />} />
        <Route path="/products/expat-horizon" element={<ExpatHorizonPage />} />
        <Route path="/schwab" element={<SchwabIntegrationPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
